



















































import { BForm, BButton } from 'bootstrap-vue';
import { reactive, computed } from '@vue/composition-api';
export default {
  components: { BForm, BButton },
  props: { emailValidation: Boolean, passwordValidation: Boolean, makingRequest: Boolean },
  setup(props: any) {
    const state = reactive({
      showSignup: false,
    });
    const loginButtonDisable = computed(() => {
      if (!props.emailValidation || !props.passwordValidation || props.makingRequest) {
        return true;
      } else {
        return false;
      }
    });
    return { props, state, loginButtonDisable };
  },
};
